import React, { ReactElement, useEffect } from 'react'
import { BasicTeaserType, TeaserProps } from '../../TeaserInterface'
import BigTeaser from '..'
import { logComponentDeprecation } from '../../../utils/Deprecation'

type TopStoryProps = BasicTeaserType &
    TeaserProps & {
        /** called when alert icon is pressed */
        onSubscribe?: () => void
        /** affects the look of the alert icon */
        subscriptionActive?: boolean
    }

const TopStory = ({
    tag,
    headlineText,
    labels,
    onShare,
    href,
    onPress,
    published,
    mainImageUrl,
    mainImageAlt,
    type,
    videoDuration,
    backgroundColor,
    textColor,
    testID,
    headlineNumberOfLines = 3,
    onSubscribe,
    subscriptionActive,
}: TopStoryProps): ReactElement => {
    /* istanbul ignore next */
    useEffect(() => {
        logComponentDeprecation('TopStorySkeleton')
    }, [])

    return (
        <BigTeaser
            isTopStory
            {...{
                tag,
                headlineText,
                labels,
                onShare,
                href,
                onPress,
                published,
                mainImageUrl,
                mainImageAlt,
                type,
                videoDuration,
                testID,
                headlineNumberOfLines,
                backgroundColor,
                textColor,
                onSubscribe,
                subscriptionActive,
            }}
        />
    )
}

export default TopStory
